import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import React from "react";
import { useSelector } from "react-redux";
import useDevotionals from "../../../hooks/useDevotionals";
import useInput from "../../../hooks/useInput";
import {
   convertDateToDDMMYYYY,
   convertDateToYYYYMMDD,
} from "../../../utilities/helper";
import { validators } from "../../../utilities/inputValidator";
import FormDesCription from "../formDescription/form-description";
import Spinner from "../spinner/spinner";
import classes from "./formDialog.module.css";

const DevotionalDialog = () => {
   const {
      devotions: { devotion, openForm, createLoading },
   } = useSelector((state) => state);

   const { closeDevotionsForm, addDevotion } = useDevotionals();

   const {
      value: title,
      valueInputChange: titleInputChange,
      valueIsValid: titleIsValid,
      hasError: titleHasError,
      inputBlurHandler: titleBlurHandler,
   } = useInput(validators.checkValueIsEmpty, `${devotion.title ?? ""}`);

   const {
      value: bibleText,
      setQuillValue: bibleTextInputChange,
      valueIsValid: bibleTextIsValid,
   } = useInput(validators.checkValueIsEmpty, `${devotion.bibleText ?? ""}`);

   const {
      value: memoryVerse,
      setQuillValue: verseInputChange,
      valueIsValid: verseIsValid,
   } = useInput(validators.checkValueIsEmpty, `${devotion.memoryVerse ?? ""}`);

   const {
      value: message,
      setQuillValue: messageInputChange,
      valueIsValid: messageIsValid,
   } = useInput(validators.checkValueIsEmpty, `${devotion.message ?? ""}`);
   const {
      value: prayerPoint,
      setQuillValue: prayerPointInputChange,
      valueIsValid: prayerPointIsValid,
   } = useInput(validators.checkValueIsEmpty, `${devotion.prayerPoint ?? ""}`);

   const {
      value: date,
      valueInputChange: dateInputChange,
      valueIsValid: dateIsValid,
      hasError: dateHasError,
      inputBlurHandler: dateBlurHandler,
   } = useInput(
      validators.checkValueIsEmpty,
      `${convertDateToYYYYMMDD(devotion.date) ?? ""}`
   );

   const {
      value: day,
      valueInputChange: dayInputChange,
      valueIsValid: dayIsValid,
      hasError: dayHasError,
      inputBlurHandler: dayBlurHandler,
   } = useInput(validators.checkValueIsEmpty, `${devotion.day ?? ""}`);

   const formIsValid =
      verseIsValid &&
      bibleTextIsValid &&
      titleIsValid &&
      dateIsValid &&
      messageIsValid &&
      prayerPointIsValid &&
      dayIsValid;

   const onAddDevotionals = () => {
      if (!formIsValid) {
         return;
      }

      const reqBody = {
         message,
         date: convertDateToDDMMYYYY(date),
         day,
         title,
         prayerPoint,
         memoryVerse,
         bibleText,
      };

      reqBody.id = devotion.id && devotion.id;

      addDevotion(reqBody);
   };
   return (
      <Dialog
         open={openForm}
         onClose={closeDevotionsForm}
         onBackdropClick={null}
      >
         <DialogTitle>Devotionals</DialogTitle>
         <DialogContent>
            <TextField
               autoFocus
               margin="dense"
               id="name"
               label="Title"
               type="text"
               fullWidth
               variant="outlined"
               value={title}
               onChange={titleInputChange}
               onBlur={titleBlurHandler}
               error={titleHasError}
            />

            <FormDesCription
               inputChange={bibleTextInputChange}
               value={bibleText}
               label="Bible Text"
            />

            <FormDesCription
               inputChange={verseInputChange}
               value={memoryVerse}
               label="Memory Verse"
            />

            <FormDesCription
               label="Message"
               inputChange={messageInputChange}
               value={message}
            />

            <FormDesCription
               inputChange={prayerPointInputChange}
               value={prayerPoint}
               label="Prayer Point"
            />

            <TextField
               margin="dense"
               id="name"
               label="Date"
               type="date"
               fullWidth
               variant="outlined"
               value={date}
               onChange={dateInputChange}
               onBlur={dateBlurHandler}
               error={dateHasError}
               placeholder=""
            />

            <TextField
               margin="dense"
               id="name"
               label="Day"
               type="text"
               fullWidth
               variant="outlined"
               value={day}
               onChange={dayInputChange}
               onBlur={dayBlurHandler}
               error={dayHasError}
            />
         </DialogContent>
         <DialogActions>
            <Button onClick={closeDevotionsForm}>Cancel</Button>
            <Button
               className={classes.button}
               variant="contained"
               onClick={onAddDevotionals}
               disabled={!formIsValid}
            >
               Save
            </Button>
         </DialogActions>

         {createLoading && <Spinner />}
      </Dialog>
   );
};

export default DevotionalDialog;
